module.exports = __webpack_public_path__ + "static/media/1377-invoice-outline (1) 1.505e4cda.svg";